import React from 'react';
import { AuthStore } from '@splunk/olly-services/lib/services/Auth/AuthStore';
import { EntityApolloContextProvider } from './EntityApolloContextProvider';
import EntityHealthContent from './EntityHealthContent';
import { API_URL } from '../../../common/consts';
import { react2angular } from 'react2angular';

interface EntityHealthContentWrapperProps {
    entityTypeSummary?: {
        contributing: boolean;
        types: string[];
    };
    isNewDetector: boolean;
    onChange: (entityTypeSummary: { contributing: boolean; types: string[] }) => void;
    dimensionsMap?: Map<string, Set<string>>;
}

const EntityHealthContentWrapper: React.FC<EntityHealthContentWrapperProps> = ({
    entityTypeSummary,
    isNewDetector,
    onChange,
    dimensionsMap,
}) => {
    const auth = AuthStore(true, API_URL);

    return (
        <EntityApolloContextProvider auth={auth}>
            <EntityHealthContent
                entityTypeSummary={entityTypeSummary}
                isNewDetector={isNewDetector}
                onChange={onChange}
                dimensionsMap={dimensionsMap}
            />
        </EntityApolloContextProvider>
    );
};

export const entityHealthContent = react2angular(EntityHealthContentWrapper, [
    'entityTypeSummary',
    'isNewDetector',
    'onChange',
    'dimensionsMap',
]);
